// Application version.
//
// Single source of truth: /version.json (injected at build time by
// vite.config.ts as __APP_VERSION__). The same value is mirrored in
// package.json and supabase/functions/_shared/version.ts for the backend.
// Bump all three together: minor for backend/schema changes, patch for
// frontend-only fixes.
declare const __APP_VERSION__: string;

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "1.2.0";

export const APP_PRODUCT_LINE = "A Product of Afritech Systems Limited";
